import React from 'react';

const Loading: React.FC = () => <h1>Loading</h1>;

export default Loading;
